import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2V22H2V2H22ZM10.1135 8.58325C10.3885 7.8051 11.1307 7.25 11.9999 7.25C13.1045 7.25 13.9999 8.14543 13.9999 9.25C13.9999 9.88718 13.7031 10.4545 13.2361 10.8223C12.8001 11.1659 12.2579 11.6092 11.8262 12.1402C11.3901 12.6765 10.9999 13.3834 10.9999 14.25V15.5H12.9999V14.25C12.9999 14.012 13.1034 13.7396 13.378 13.4019C13.657 13.0588 14.0423 12.7334 14.4739 12.3933C15.4014 11.6625 15.9999 10.5259 15.9999 9.25C15.9999 7.04086 14.2091 5.25 11.9999 5.25C10.2567 5.25 8.77642 6.36451 8.22778 7.91675L7.89453 8.85959L9.78021 9.52609L10.1135 8.58325ZM13.0036 16.5H10.9997V18.5039H13.0036V16.5Z"}}]};

const HelpRectangleFilled = Vue.extend<IconProps>({
  name: 'HelpRectangleFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'help-rectangle-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default HelpRectangleFilled;
